// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBteMiKoJ2AqYMcNemJeV0k-s0j-0USHTg",
    authDomain: "gestor-proyectos-b593e.firebaseapp.com",
    projectId: "gestor-proyectos-b593e",
    storageBucket: "gestor-proyectos-b593e.firebasestorage.app",
    messagingSenderId: "644859685089",
    appId: "1:644859685089:web:56c79ee23db1f501fdafa0",
    measurementId: "G-2XYSHT4N13"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();
provider.setCustomParameters({
    'hd': 'iets.org.co'
});

const signInWithGoogle = async (useRedirect = false, retryCount = 0) => {
    const maxRetries = 2;
    
    try {
        let result;
        
        if (useRedirect) {
            // Usar redirect como alternativa
            const { signInWithRedirect, getRedirectResult } = await import('firebase/auth');
            
            // Verificar si hay un resultado de redirect pendiente
            const redirectResult = await getRedirectResult(auth);
            if (redirectResult) {
                result = redirectResult;
            } else {
                // Iniciar el flujo de redirect
                await signInWithRedirect(auth, provider);
                return null; // El resultado se manejará en la próxima carga de página
            }
        } else {
            // Usar popup (método preferido)
            result = await signInWithPopup(auth, provider);
        }
        
        const user = result.user;
        if (!user.email.endsWith('@iets.org.co')) {
            await auth.signOut();
            throw new Error('Solo usuarios con dominio @iets.org.co pueden acceder');
        }
        
        console.log('✅ Autenticación exitosa:', user.email);
        return user;
        
    } catch (error) {
        console.error('Error en autenticación:', error.code, error.message);
        
        // Manejo específico de errores
        switch (error.code) {
            case 'auth/popup-closed-by-user':
                if (retryCount < maxRetries && !useRedirect) {
                    console.log(`🔄 Reintentando autenticación (intento ${retryCount + 1}/${maxRetries + 1})`);
                    // Esperar un poco antes de reintentar
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    return signInWithGoogle(false, retryCount + 1);
                } else if (!useRedirect) {
                    // Si fallan los reintentos con popup, intentar con redirect
                    console.log('🔄 Cambiando a método de redirect...');
                    return signInWithGoogle(true, 0);
                } else {
                    throw new Error('El popup de autenticación fue cerrado. Por favor, intenta nuevamente y completa el proceso de inicio de sesión.');
                }
                
            case 'auth/popup-blocked':
                console.log('🚫 Popup bloqueado, usando redirect...');
                return signInWithGoogle(true, 0);
                
            case 'auth/cancelled-popup-request':
                if (retryCount < maxRetries) {
                    console.log(`🔄 Solicitud cancelada, reintentando (${retryCount + 1}/${maxRetries + 1})`);
                    await new Promise(resolve => setTimeout(resolve, 1500));
                    return signInWithGoogle(useRedirect, retryCount + 1);
                } else {
                    throw new Error('La solicitud de autenticación fue cancelada. Por favor, intenta nuevamente.');
                }
                
            case 'auth/network-request-failed':
                throw new Error('Error de conexión. Verifica tu conexión a internet e intenta nuevamente.');
                
            case 'auth/too-many-requests':
                throw new Error('Demasiados intentos de inicio de sesión. Por favor, espera unos minutos antes de intentar nuevamente.');
                
            case 'auth/user-disabled':
                throw new Error('Esta cuenta ha sido deshabilitada. Contacta al administrador.');
                
            case 'auth/operation-not-allowed':
                throw new Error('El inicio de sesión con Google no está habilitado. Contacta al administrador.');
                
            default:
                // Para errores no específicos, intentar una vez más con redirect si no se ha intentado
                if (!useRedirect && retryCount === 0) {
                    console.log('🔄 Error desconocido, intentando con redirect...');
                    return signInWithGoogle(true, 0);
                }
                throw new Error(`Error de autenticación: ${error.message || 'Error desconocido'}`);
        }
    }
};

export { db, auth, storage, signInWithGoogle };